/*
 * @Author: HuangChaoYi
 * @email: 1089109@qq.com
 * @Date: 2025-06-15 10:44:11
 * @LastEditTime: 2025-07-24 16:27:04
 * @LastEditors: 黄朝忆 1089109@qq.com
 * @Description: 
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './APP';
import { ConfigProvider } from 'antd';
// 汉化
import zhCN from 'antd/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { HashRouter } from 'react-router-dom';
dayjs.locale('zh-cn')

// 开发环境注入 Mock 拦截（使用 mockjs），生产环境不加载
if (process.env.NODE_ENV === 'development') {
  // 动态导入，避免打包到生产
  import('./mock');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <HashRouter>
      <ConfigProvider locale={zhCN}>
        <App />
      </ConfigProvider>
    </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
